import Profile from './Profile';

export default Profile;



// WEBPACK FOOTER //
// ./src/components/common/Profile/index.js